export const SignUpPages = {
    SCAN_QR_EMAIL: 'scanQREmail',
    INPUT_REG_CODE: 'inputRegCode',
    INPUT_REG_EMAIL: 'inputRegEmail',
    EMAIL_CONFIRMATION: 'emailConfirmation'
}